export default "__VITE_ASSET__B2JfXHed__"